import moment from "moment";
export const validImageExtensions = ['jpeg', 'png', 'jpg', 'webp'];
export const dateSuffix = num => {
	const b = num % 10;
	const output = (~~(num % 100 / 10) === 1) ? 'th' :
		(b === 1) ? 'st' :
			(b === 2) ? 'nd' :
				(b === 3) ? 'rd' : 'th';
	return output;
}
export const getYearsList = () => {
	let startYear = 2020;
	let yearArray = [];
	for (let i = 2020; i <= 2030; i++) {
		startYear = startYear + 1;
		yearArray.push({ optVal: startYear, optName: `${startYear - 1}-${startYear}` })
	}
	return yearArray;
}
export const createYearList = (yearArray) => {
	let yearList = [];
	for (let i of yearArray) {
		yearList.push({ optVal: i.financial_year_from, optName: `${i.financial_year_from}-${i.financial_year_to}` });
	}
	return yearList;
}
export const getFinancialYear = (mon, year) => {
	// || mon === 1
	if (mon > 1) {
		return parseInt(year) + 1;
	}
	return parseInt(year);
}
export const shortMonths = ['Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'];
export const MonthList = ["November", "December", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October"];
export const MonthObjectList = [
	{ id: 0, name: "November" },
	{ id: 1, name: "December" },
	{ id: 2, name: "January" },
	{ id: 3, name: "February" },
	{ id: 4, name: "March" },
	{ id: 5, name: "April" },
	{ id: 6, name: "May" },
	{ id: 7, name: "June" },
	{ id: 8, name: "July" },
	{ id: 9, name: "August" },
	{ id: 10, name: "September" },
	{ id: 11, name: "October" }
];
export const formatDate = (dateString, time = false) => {
	if (time === true) {
		return moment(dateString).format('DD-MM-YYYY h:iA');
	}
	return moment(dateString).format('DD-MM-YYYY');
}
export function humanFileSize(bytes, dp = 1) {
	const thresh = 1024;
	if (Math.abs(bytes) < thresh) {
		return bytes + ' B';
	}
	const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	let u = -1;
	const r = 10 ** dp;
	do {
		bytes /= thresh;
		++u;
	} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
	return bytes.toFixed(dp) + ' ' + units[u];
}
export const uploadLabelTemplate = (fileVal, forLabel) => {
	if (fileVal == null || typeof fileVal === "undefined") {
		return (
			<label style={{ backgroundColor: 'white' }} htmlFor={(forLabel != "") ? forLabel : "eoi_file"}>
				<i className="icon-upload"></i>{" "}
				Upload
			</label>
		)
	}
	return (
		<label htmlFor={(forLabel != "") ? forLabel : "eoi_file"}>
			<i className="icon-file"></i>
			<div className="file-name-size">
				<span className="file-name">{fileVal.name}
					<span className="file-size">{humanFileSize(fileVal.size)}</span>
				</span>
			</div>
		</label>
	)
}

export const debounce = (func) => {
	let timer;
	return function (...args) {
		const context = this;
		if (timer) clearTimeout(timer);
		timer = setTimeout(() => {
			timer = null;
			func.apply(context, args);
		}, 500);
	};
};
export const pageTabTitle = (pagetitle) => {
	if (pagetitle !== "") {
		return `${pagetitle} | Burhani Guards Indore`
	}
	return `Burhani Guards Indore`
}
export const convertArrayItemStringToInt = (array) => {
	let IntArray = [];
	if (array.length > 0) {
		for (let i of array) {
			IntArray.push(parseInt(i));
		}
	}
	return IntArray;
}

export const findBykey = (e, key, val) => {
	let keyFound = false;
	for (let o of e) {
		if (o[key] == val) {
			keyFound = true;
			break;
		}
		if (o.children.length > 0) {
			keyFound = findBykey(o.children, key, val);
			if (keyFound === true) {
				break;
			}
		}
	}
	return keyFound;
}
export const filterMultidimensional = (array) => {
	return array.filter(elm => {
		if (elm !== null) {
			if (typeof elm.children !== "undefined" && elm.children.length > 0) { elm.children = filterMultidimensional(elm.children) }
			return elm;
		}
	});
}

export const getCustomLinkLength = (array) => {
	let customLink = 0;
	for (let i of array) {
		if (i.menu_type === 'external_link') {
			customLink += 1
		}
		if (i.children.length > 0) {
			customLink += getCustomLinkLength(i.children);
		}
	}
	return customLink;
}
export const getCurrentFinancialYear = () => {
	const currentDate = new Date();
	const currentYear = currentDate.getFullYear();
	const currentMonth = (currentDate.getMonth() + 1);
	let returnVal = '';
	if (currentMonth === 11 || currentMonth === 12) {
		returnVal = `${currentYear}-${currentYear + 1}`
	}
	else {
		returnVal = `${currentYear - 1}-${currentYear}`
	}

	return returnVal;
}
export const numberFormat = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const numberFormat0Decimal = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
export const numberFormatCustom = (value, min = 2, max = 2) => new Intl.NumberFormat('en-IN', { minimumFractionDigits: min, maximumFractionDigits: max }).format(value);
export const sleepJs = (time) => {
	return new Promise(resolve => setTimeout(resolve, time));
}
export const reconcileStatuses = ["Yet to Reconcile", "Request Sent to Supplier", "Accepted", "Send Back", "Provisionally debited by location"];
export const reconciliatsStatus = (status = '') => {
	let statuses = ["Yet to Reconcile", "Request Sent to Supplier", "Accepted", "Send Back", "Provisionally debited by location"];
	if (status === 2) {
		return <button className="status-btn bg-btn approved disabled" >{statuses[status]}</button>;
	}
	else if (status === 3) {
		return <button className="status-btn bg-btn rejected disabled" >{statuses[status]}</button>;
	}
	else if (status !== "") {
		return statuses[status];
	}
	return statuses;
}

export const geValuebyKey = (object, key) => {
	let value = '';
	for (let i in object) {
		if ((object[i].parameters === key)) {
			value = object[i].value;
			break;
		}
	}
	return value
}

export const CapitalFirstLetterString = (string) => {
	return string.charAt(0).toUpperCase() + (string.slice(1)).toLowerCase();
}

export const prcEventTypes = {
	'dr_fl': 'Drought / Flood',
	'eq_cy_ts': 'Earthquake / Cyclone / Tsunami',
	'fi_ac_ex': 'Fire/Accident / Explosion',
	'ep_pd_qr_pl': 'Epidemic / Pandemic / Quarantine / Plague',
	'st_sa_bl_em_cd_re': 'Strike / Sabotage / Blockage / Embargos / Civil Disturbance / Rebellion',
	'others': 'Others'
}

export const getCurrentQuarter = () => {
	let curDate = new Date();
	let curMonth = curDate.getMonth() + 1;
	let quarter = 4;
	if (curMonth === 11 || curMonth === 12 || curMonth === 1) {
		quarter = 1;
	}
	else if (curMonth === 2 || curMonth === 3 || curMonth === 4) {
		quarter = 2;
	}
	else if (curMonth === 5 || curMonth === 6 || curMonth === 7) {
		quarter = 3;
	}
	return quarter;
}
export const prcStatuses = {
	'submitted': 'Submitted',
	'approved': 'Approved',
	'send_back': 'Sent Back',
	'rejected': 'Rejected'
}